var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTool2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 42,
    viewBox: "0 0 29 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_449)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.83658 42C11.7006 42 14.8366 38.864 14.8366 35V28H7.83658C3.97258 28 0.836578 31.136 0.836578 35C0.836578 38.864 3.97258 42 7.83658 42Z",
    fill: "#0ACF83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.836578 21C0.836578 17.136 3.97258 14 7.83658 14H14.8366V28H7.83658C3.97258 28 0.836578 24.864 0.836578 21Z",
    fill: "#A259FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.836578 7C0.836578 3.136 3.97258 0 7.83658 0H14.8366V14H7.83658C3.97258 14 0.836578 10.864 0.836578 7Z",
    fill: "#F24E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8366 0H21.8366C25.7006 0 28.8366 3.136 28.8366 7C28.8366 10.864 25.7006 14 21.8366 14H14.8366V0Z",
    fill: "#FF7262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8366 21C28.8366 24.864 25.7006 28 21.8366 28C17.9726 28 14.8366 24.864 14.8366 21C14.8366 17.136 17.9726 14 21.8366 14C25.7006 14 28.8366 17.136 28.8366 21Z",
    fill: "#1ABCFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_449"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 42,
    fill: "white",
    transform: "translate(0.836578)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTool2);
export default __webpack_public_path__ + "static/media/tool2.7b5624d4ce515c482bd6edc5c817deec.svg";
export { ForwardRef as ReactComponent };